import React, { useState } from 'react';
import { toast } from 'react-toastify';

// Endpoint Mexico (profile_monkey3) via API Gateway MX
const PROFILE_URL = 'https://skeuoyitdc.execute-api.mx-central-1.amazonaws.com/prod/profile2';

async function callProfile(payload) {
  const res = await fetch(PROFILE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const result = await res.json();
  // La respuesta puede venir con body (string o dict) o directa
  if (result && result.body !== undefined) {
    return typeof result.body === 'string' ? JSON.parse(result.body) : result.body;
  }
  return result;
}

export default function AdminLineas() {
  // --- Cambio de SIM ---
  const [swMsisdn, setSwMsisdn] = useState('');
  const [swIccid, setSwIccid] = useState('');
  const [swCargando, setSwCargando] = useState(false);
  const [swResultado, setSwResultado] = useState(null);

  // --- Operaciones / Portabilidad ---
  const [opMsisdn, setOpMsisdn] = useState('');
  const [opCargando, setOpCargando] = useState(false);
  const [operaciones, setOperaciones] = useState(null);

  const cambiarSim = async () => {
    if (!swMsisdn || !swIccid) {
      toast.warn('Ingresa número y el ICCID de la nueva SIM');
      return;
    }
    setSwCargando(true);
    setSwResultado(null);
    try {
      const body = await callProfile({
        msisdn: swMsisdn.trim(),
        iccid_nuevo: swIccid.trim(),
        serv: 'cambio_sim',
        env: 'prod',
      });
      setSwResultado(body);
      if (body?.response === 'ok') {
        toast.success('✅ Cambio de SIM exitoso');
      } else {
        toast.error(`❌ No se pudo realizar el cambio de SIM`);
      }
    } catch (e) {
      console.error(e);
      toast.error('Error de conexión al cambiar SIM');
    } finally {
      setSwCargando(false);
    }
  };

  const consultarOperaciones = async () => {
    if (!opMsisdn) {
      toast.warn('Ingresa un número para consultar');
      return;
    }
    setOpCargando(true);
    setOperaciones(null);
    try {
      const body = await callProfile({
        msisdn: opMsisdn.trim(),
        serv: 'operaciones',
        env: 'prod',
      });
      const ops = Array.isArray(body?.operaciones) ? body.operaciones : [];
      setOperaciones(ops);
      if (ops.length === 0) {
        toast.info('Sin operaciones registradas para este número');
      }
    } catch (e) {
      console.error(e);
      toast.error('Error de conexión al consultar operaciones');
    } finally {
      setOpCargando(false);
    }
  };

  // Determina si un mensaje de operacion es de portabilidad
  const esPortabilidad = (msg) => /port|ported/i.test(msg || '');

  const input = {
    width: '100%', padding: 12, borderRadius: 10, border: '1px solid #cbd5e1',
    fontSize: 14, boxSizing: 'border-box', marginBottom: 10,
  };
  const card = {
    background: '#fff', borderRadius: 16, padding: 18,
    boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 20,
  };

  return (
    <div style={{ marginTop: 20 }}>
      {/* ====== CAMBIO DE SIM ====== */}
      <div style={card}>
        <h2 style={{ marginTop: 0 }}>📲 Cambio de SIM</h2>
        <p style={{ fontSize: 13, color: '#6b7280', marginTop: 0 }}>
          Migra el número a una nueva SIM. La nueva SIM (ICCID) debe estar disponible (Idle).
        </p>
        <input
          style={input}
          placeholder="Número (MSISDN) a migrar"
          value={swMsisdn}
          onChange={(e) => setSwMsisdn(e.target.value)}
        />
        <input
          style={input}
          placeholder="ICCID de la nueva SIM"
          value={swIccid}
          onChange={(e) => setSwIccid(e.target.value)}
        />
        <button onClick={cambiarSim} disabled={swCargando} className="orange-button" style={{ width: '100%' }}>
          {swCargando ? '⏳ Procesando...' : '📲 Realizar cambio de SIM'}
        </button>
        {swResultado && (
          <div style={{
            marginTop: 12, padding: 12, borderRadius: 10,
            background: swResultado.response === 'ok' ? '#dcfce7' : '#fee2e2',
            fontSize: 13, color: '#1f2937', wordBreak: 'break-word',
          }}>
            <strong>Resultado:</strong> {swResultado.response === 'ok' ? '✅ Exitoso' : '❌ No completado'}
            {swResultado.detalle && (
              <div style={{ marginTop: 6, fontSize: 12, color: '#6b7280' }}>{String(swResultado.detalle).slice(0, 300)}</div>
            )}
          </div>
        )}
      </div>

      {/* ====== OPERACIONES / PORTABILIDAD ====== */}
      <div style={card}>
        <h2 style={{ marginTop: 0 }}>🔁 Operaciones y Portabilidad</h2>
        <p style={{ fontSize: 13, color: '#6b7280', marginTop: 0 }}>
          Histórico de operaciones de la línea (portabilidad, cambio de SIM, APN, etc.).
        </p>
        <input
          style={input}
          placeholder="Número (MSISDN) a consultar"
          value={opMsisdn}
          onChange={(e) => setOpMsisdn(e.target.value)}
        />
        <button onClick={consultarOperaciones} disabled={opCargando} className="orange-button" style={{ width: '100%' }}>
          {opCargando ? '⏳ Consultando...' : '🔁 Consultar operaciones'}
        </button>

        {operaciones && operaciones.length > 0 && (
          <div style={{ marginTop: 14, maxHeight: 360, overflowY: 'auto' }}>
            {operaciones.map((o, i) => (
              <div key={i} style={{
                padding: '10px 12px', marginBottom: 8, borderRadius: 10,
                background: esPortabilidad(o.message) ? '#eff6ff' : '#f8fafc',
                border: esPortabilidad(o.message) ? '1px solid #bfdbfe' : '1px solid #e2e8f0',
              }}>
                <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 2 }}>
                  {o.operation_date}
                  {esPortabilidad(o.message) && (
                    <span style={{
                      marginLeft: 8, background: '#2563eb', color: '#fff',
                      borderRadius: 6, padding: '1px 6px', fontSize: 10, fontWeight: 700,
                    }}>PORTABILIDAD</span>
                  )}
                </div>
                <div style={{ fontSize: 13, color: '#1f2937' }}>{o.message}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{ height: 80 }} />
    </div>
  );
}
